export const courseId=value=>String(value?._id||value||'');
export function studentCourses(student={}){const seen=new Set();return [student.course,...(student.additionalCourses||[])].filter(course=>{const key=courseId(course);if(!key||seen.has(key))return false;seen.add(key);return true;});}
export const courseNames=student=>studentCourses(student).map(c=>c.name||'Course unavailable').join('; ');
export function studentMentors(student){return student.currentMentors||[{courseId:courseId(student.course),courseName:student.course?.name,...student.currentMentor}];}
export const mentorNames=student=>studentMentors(student).map(m=>`${m.courseName||'Course'}: ${m.mentorId?m.mentorName:'Unassigned'}`).join('; ');

// Cards already show course names above. Keep course-to-mentor mappings in exports.
export function mentorCardLabel(student) {
  const rows = studentMentors(student);
  const seen = new Set();
  const names = rows.filter(row => {
    const id = courseId(row.mentorId);
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  }).map(row => row.mentorName || 'Name unavailable');
  if (!names.length) return 'Unassigned';
  return names.join(', ') + (rows.some(row => !row.mentorId) ? ' · Some courses unassigned' : '');
}
